import { Component } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-barra',
  templateUrl: './barra.component.html',
  styles: []
})
export class BarraComponent {

  public fileError: string = '';

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartLabels: string[] = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  public barChartType:   string   = 'bar';
  public barChartLegend: boolean  = true;

  public barChartData: any[] = [
    {data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A'},
    {data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B'}
  ];

  constructor() {}

  public chartClicked(e: any): void { console.log(e); }
  public chartHovered(e: any): void { console.log(e); }

  public randomize(): void {
    const data = [
      Math.round(Math.random() * 100), 59, 80,
      Math.round(Math.random() * 100), 56,
      Math.round(Math.random() * 100), 40
    ];
    const clone = JSON.parse(JSON.stringify(this.barChartData));
    clone[0].data = data;
    this.barChartData = clone;
  }

  /**
   * Formato esperado (hoja "Barra" o primera hoja):
   *   Fila 1: Series     | 2018 | 2019 | ...   ← cabecera
   *   Fila 2: Producto A | 55   | 62   | ...
   *   Fila 3: Producto B | 40   | 44   | ...
   * Filas sin valores numéricos (notas) se ignoran.
   */
  public loadFromExcel(event: any): void {
    this.fileError = '';
    const file = event.target.files[0];
    if (!file) { return; }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const workbook = XLSX.read(e.target.result, { type: 'binary' });

        const sheetName = workbook.SheetNames.find(
          n => n.toLowerCase() === 'barra'
        ) || workbook.SheetNames[0];

        const sheet = workbook.Sheets[sheetName];
        const rows: any[][] = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });

        if (rows.length < 2) {
          this.fileError = 'El archivo debe tener al menos una fila de cabecera y una de datos.';
          return;
        }

        const headerRow = rows[0];

        // Keep only rows that have at least one numeric value after the first cell
        const dataRows = rows.slice(1).filter(row => {
          return row.slice(1).some((v: any) => v !== '' && !isNaN(Number(v)));
        });

        if (dataRows.length === 0) {
          this.fileError = 'No se encontraron filas de datos válidos.';
          return;
        }

        const firstCell    = dataRows[0][0];
        const firstIsLabel = isNaN(Number(firstCell)) && String(firstCell).trim() !== '';

        let newLabels: string[];
        let newData: any[];

        if (firstIsLabel) {
          newLabels = headerRow.slice(1).filter((v: any) => v !== '').map(String);
          newData   = dataRows.map((row, i) => ({
            label: String(row[0]) || `Series ${i + 1}`,
            data:  row.slice(1, newLabels.length + 1).map((v: any) => Number(v) || 0)
          }));
        } else {
          newLabels = headerRow.filter((v: any) => v !== '').map(String);
          newData   = dataRows.map((row: any[], i: number) => ({
            label: `Series ${i + 1}`,
            data:  row.slice(0, newLabels.length).map((v: any) => Number(v) || 0)
          }));
        }

        if (newData.length === 0 || newLabels.length === 0) {
          this.fileError = 'No se encontraron datos válidos.';
          return;
        }

        this.barChartLabels = [...newLabels];
        this.barChartData   = [...newData];

      } catch (err) {
        this.fileError = 'Error al leer el archivo Excel.';
        console.error(err);
      }
    };

    reader.readAsBinaryString(file);
    event.target.value = '';
  }
}